import React, { useEffect, useState } from 'react';
import styled from "styled-components";
import { DashboardIcon, Header } from '../../Components/PageComponents';
import ReactGA from "react-ga4";
import { ParamAPI } from 'API/GeneralAPI';

const PdfContainer = styled.div`
    position: relative;
    padding-bottom: 70.75%;
    height: 0;
    overflow: hidden;
`;
const PdfPanel = styled.div`
    width: 100%;
    @media (min-width: 1050px) {
        width: 75%;
    }
`;
const Pdf = styled.iframe`
    position: absolute;
    top:0;
    left: 0;
    width: 100%;
    height: 100%;
`;

function TermsCons() {

    const [termsConditionsUrl, setTermsConditionsUrl] = useState<string>('');
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });

    useEffect(() => {
        const getTermsConditions = async () => {
            const url = await ParamAPI.get("tandc");
            setTermsConditionsUrl(url);
        }
        getTermsConditions();

    }, []);

    

    return (
        <PdfPanel>
            <DashboardIcon src="/images/homepage/calendar.png"/>
            <Header>Rules/Terms and Conditions</Header>
            <PdfContainer>
                <Pdf src={termsConditionsUrl} width="100%" height="100%"></Pdf>
            </PdfContainer>
        </PdfPanel>
    );
}
export default TermsCons;
